<template>
<section class="flex md:flex-col">
    <div>
        <AdminDashboardNav/>
    </div>
    <section class="background-image pl-10 pr-10 md:p-2 w-screen font-poppins">
        <section class="mt-6 ">
            <div class=" flex justify-between md:flex-col-reverse">
                <div>
                    <GetDate/>
                    <p class="text-blue-700 font-bold text-2xl">LOGOUT</p>
                </div>

                <div class=" mr-10">
                    <Notification/>
                </div>
            </div>
        </section>

        <section>
            <ConfirmLogout v-show="isModalVisible"
            @close="closeModal"/>
        </section>
    </section>
</section>    
</template>

<script>
import GetDate from '../GetDate.vue';
import AdminDashboardNav from '../AdminDashboardNav.vue';
import Notification from '../Notification.vue';
import ConfirmLogout from './ConfirmLogout.vue'
export default {
    components: {
        AdminDashboardNav,
        GetDate,
        Notification,
        ConfirmLogout
    },

    data() {
        return {
            isModalVisible : true
        }
    },

    mounted() {
        this.networkError()
    },

    methods: {
        showModal() {
        this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
        },
        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>

